import React from "react";
import Menu from "antd/lib/menu";
import Dropdown from "antd/lib/dropdown";
import Icon from "antd/lib/icon";
import PropTypes from "prop-types";
import steps from "./steps.js";
import { connect } from "react-redux";
import { changeStep } from "../actions.js";
const MenuItem = Menu.Item;

const StepTitle = props => {
  const step = steps[props.stepNumber];
  const titleText = step.titleText;
  const titleIcon = step.titleIcon;

  return (
    <div id="area" style={{ marginBottom: "10px" }}>
      <Dropdown
        placement="bottomCenter"
        overlay={
          <Menu onClick={props.changeStep}>
            {steps.map((step, index) => {
              return (
                <MenuItem key={index} style={{fontSize: "7pt", backgroundColor: "#24252a", color: "white"}}>
                  {index + 1}. {step.titleText}
                </MenuItem>
              );
            })}
          </Menu>
        }
        getPopupContainer={() => document.getElementById("area")}
      >
        <a style={{ letterSpacing: "1px", color: "white" }}>
          <Icon type={titleIcon} /> 
          <span style={{fontWeight: "600"}}>
            {" "}{titleText}{" "}
          </span>
          <Icon style={{ color: "#4353ff" }} type="down" />
        </a>
      </Dropdown>
    </div>
  );
};

StepTitle.propTypes = {
  stepNumber: PropTypes.number,
  changeStep: PropTypes.func
};

function mapStateToProps(state) {
  return {
    stepNumber: state.step
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeStep: step => {
      dispatch(changeStep(Number(step.key)));
    }
  };
}

const StepTitleContainer = connect(mapStateToProps, mapDispatchToProps)(
  StepTitle
);

export default StepTitleContainer;



// WEBPACK FOOTER //
// ./src/steps/StepTitle.js